import { render, staticRenderFns } from "./CampaignTabs.vue?vue&type=template&id=3aeb1478&scoped=true&"
import script from "./CampaignTabs.vue?vue&type=script&lang=js&"
export * from "./CampaignTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb1478",
  null
  
)

export default component.exports